export default {
  driedAbaloneSummaryItems: [],
  driedAbaloneSummaryItem: undefined,
};
